export default __webpack_public_path__ + "static/Linh_Han-3b60048688f3a13d208eb0af1f2900c6.png";